var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-box",class:{ 'animated': _vm.animated },style:(("\n    width: " + _vm.width + ";\n    height: " + (_vm.height ? _vm.height : _vm.sizes[_vm.variant]) + ";\n  "))})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db05efb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/skeleton/SkeletonItem.vue
// module id = null
// module chunks = 